import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import logo from "@/assets/vvm-logo-official.png";

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <img src={logo} alt="Voice Vision Media Logo" className="h-16 w-auto mb-4" />
            <h3 className="text-lg font-bold mb-2">Voice Vision Media</h3>
            <p className="text-sm opacity-90">
              Empowering businesses with AI Virtual Employees
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-accent transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-accent transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-accent transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/faqs" className="hover:text-accent transition-colors">
                  FAQs
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Industries</h4>
            <ul className="space-y-2 text-sm opacity-90">
              <li>Healthcare</li>
              <li>Skilled Trades</li>
              <li>Small Business</li>
              <li>Distribution</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <div className="space-y-2 text-sm">
              <a
                href="mailto:voice.vision.media.roc@gmail.com"
                className="flex items-center hover:text-accent transition-colors"
              >
                <Mail className="w-4 h-4 mr-2" />
                voice.vision.media.roc@gmail.com
              </a>
              <a
                href="tel:+15858315114"
                className="flex items-center hover:text-accent transition-colors"
              >
                <Phone className="w-4 h-4 mr-2" />
                (585) 831-5114
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-primary-foreground/20 pt-6 text-center text-sm opacity-80">
          <p>&copy; {new Date().getFullYear()} Voice Vision Media. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
